import {navigationPaths} from "./navigation-path"

export const BedarfsCheckActions = ({
                                        navigate,
                                    }) => ({
    BC_NAVIGATGE_TO_HOME: () => navigate(navigationPaths.LIVE_COCKPIT),
})